// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"725":"d8f62a02c2702d70","802":"206af35bac66de2f"}[chunkId] + ".css";
};